<template>
  <v-container class="py-0">
    <v-form ref="notaFiscalForm" :value="formValid">
      <v-row class="py-0">
        <v-col class="py-0 px-2" cols="12">
          <label>Número</label>
          <v-text-field
            v-model="numero"
            type="number"
            placeholder="Número da nota fiscal"
            single-line
            outlined
            dense
            :rules="formRules.required"
          ></v-text-field>
        </v-col>
        <v-col class="py-0 px-2" cols="6">
          <label>Data de emissão</label>
          <v-menu
            ref="dtI"
            v-model="dtI"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormatted"
                dense
                v-mask="'##/##/####'"
                format="DD/MM/YYYY"
                placeholder="DD/MM/AAAA"
                label
                outlined
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar-blank"
                @blur="date = parseDate(dateFormatted)"
                :rules="[obrigatorio && obrigatorio.includes('dt_emissao') ?formRules.requiredField :null, formRules.typeDateFormated]"
              ></v-text-field>
            </template>
            <v-date-picker color="primary"  v-model="date" no-title scrollable></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="py-0 px-2" cols="6" v-if="showField">
          <label>Valor (R$)</label>
          <v-text-field
            v-model.lazy="valor"
            v-money= "money"
            outlined
            dense
            :rules="obrigatorio && obrigatorio.includes('valor')? formRules.requiredPrice: []"
          />
        </v-col>
        <v-col class="py-0 px-2" cols="12">
          <label>Link da nota</label>
          <v-text-field
            v-model="link"
            placeholder="Ex.: http://www.nfe.fazenda.gov.br/13443556779080"
            single-line
            outlined
            dense
            :rules="obrigatorio && obrigatorio.includes('link')? formRules.required.concat(formRules.validUrl)  : formRules.validUrl"
          ></v-text-field>
        </v-col>
        <v-col class="py-0 px-2" cols="12">
          <label>Anexo</label>
          <v-file-input
              :placeholder="formData.anexo == null ? 'Selecione o arquivo da nota' : formData.anexo"
              outlined
              v-model="file"
              single-line
              dense
              :prepend-icon="null"
              append-icon="fa-upload"
              :rules="obrigatorio && obrigatorio.includes('anexo') && isNew? formRules.required : []"
              @change="sendFile(file)"
          ></v-file-input>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { VMoney } from "v-money";
import { mapState } from "vuex";
export default {
  directives: { money: VMoney },
  data() {
    return {
      isNew: true,
      file: null,
      dateFormatted: null,
      date: null,
      dtI: false,
      valor: null,
      link: null,
      numero: null,
      anexo: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      showField: true,
      // obrigatorio:{
      //   anexo: true, 
      //   dt_emissao: false,
      //   link: true,
      //   valor: false,
      // },
      formValid: true
    };
  },
  watch: {
    anexo(val){
      this.formData.anexo = val
    },
    valor(val) {
      this.formData.valor = val? parseFloat(this.valor.replaceAll('.','').replaceAll(',','.')) : null
    },
    validateForm(val){
      if(val) {
        this.notaFiscalFormValid.isValid =  this.$refs.notaFiscalForm.validate() ? true : false
      }
    },
    link(val){
      this.formData.link = val
    },
    numero(val){
      this.formData.numero = val
    },
    dateFormatted(val) {
      this.formData.dt_emissao = this.parseDate(val);
    },
    date(val) { 
      this.dateFormatted = this.formatDate(val);
    },
    formData(val) {
        // this.$refs.notaFiscalForm.reset()
        this.valorNota(0.00)
        this.$nextTick(()=> {
        if(val  && val.id){
          this.isNew = false
          this.numero = val.numero
          this.link = val.link
          this.date = val.dt_emissao
          this.valorNota(val.valor)
        } 
        else {
          this.isNew = true
          this.file = null
          this.valor = 0.00
          this.numero = null
          this.link = null
          this.date = null
        }
          setTimeout(()=>{
            this.$refs.notaFiscalForm.resetValidation()
          },50)
        })
    },
  },
  mounted(){
     setTimeout(()=>{
            this.$refs.notaFiscalForm.resetValidation()
          },50)
    
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules: (state) => state.formRules,
    }),
  },
  methods: {
    valorNota(val) {
      this.showField = false
      if(val){
        this.valor = (val/1).toFixed(2).toString().replace('.', ',')
        this.valor = this.valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
      setTimeout(() => {
        this.showField = true
      }, 30)
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('T')[0].split('-')
        return `${day}/${month}/${year}`
    },
    // dateEmissao(date) {
    //     if (!date) return null
    //     return date.split('T')[0]
    // },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
  },
  props: {
    formData: Object,
    sendFile: Function,
    validateForm: Boolean,
    notaFiscalFormValid: Object,
    obrigatorio: Array
  }
};
</script>